import { generateSetChild } from '@/helpers/VuexHelpers'

export default {
	namespaced: true,
	state: {
		status: false,
		title: '',
		message: '',
	},
	actions: {
		errorShow({commit, state}, {title = '', message = ''} = {}) {

			if (state.title !== title) {
				commit('setTitle', {item: title});
			}

			if (state.message !== message) {
				commit('setMessage', {item: message});
			}

			commit('setStatus', {item: true});
		},
		errorHide({commit}) {
			commit('setStatus', {item: false});
		},
	},
	getters: {
		errorTitle(state) {
			return state.title
		},
		errorMessage(state) {
			return state.message
		},
		errorStatus(state) {
			return state.status
		}
	},
	mutations: {
		setTitle: generateSetChild("title"),
		setMessage: generateSetChild("message"),
		setStatus: generateSetChild("status"),
	}
}